<template>
  <div class="hello text-center mt-4">
    <a href="https://altoar.io">Altoar.io</a>
    <div class="">
      <h4>Implement VoteNow OBS browser source with https://voteonstream.com/obs/yourtwitchname</h4>
      set browser source width to 1920px
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue